// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"styles_resultsWrapper__2Zzih","matchList":"styles_matchList__y0Z2N"};